import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const initHowItWorks = () => {
  document.querySelectorAll('[data-how-it-works]').forEach((howItWorks) => {
    let pin = howItWorks.querySelector('.section-pin');
    let steps = howItWorks.querySelectorAll('[data-how-it-works-step]');
    let stepScroller = howItWorks.querySelector('[data-how-it-works-step-scroller]');
    let stepScrollerWrapper = stepScroller.parentNode;

    gsap.set(howItWorks, { height: window.innerHeight + ((stepScroller.offsetHeight - stepScrollerWrapper.offsetHeight) * 2) });

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: howItWorks,
        start: 'top top',
        end: 'bottom bottom',
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    /*
        pin: pin,
        snap: {
          snapTo: 'labels',
          duration: { min: 0.2, max: 1 },
          delay: 0.1,
          directional: true
        },
    */

    steps.forEach((step, index) => {

      if(index === 0) {
        step.classList.add('hiw-step--active');
      } else {
        //tl.to({}, { duration: 0.25, ease: 'none' });
        tl.to(stepScroller, {
          y: '-='+step.offsetHeight,
          duration: 1,
          ease: 'none'
        }, 'step-'+index);

        tl.call(() => {
          if(index > 0) {
            steps[index - 1].classList.toggle('hiw-step--active');
          }
          step.classList.toggle('hiw-step--active');
        }, [], '-=0.5');
      }

    });
  });
};

export { initHowItWorks };